export const localized = (key) => (dispatch, getState) => {
  try {
    const localizedString = key.split('.').reduce((a, b) => a[b], getState().localize.strings);
    if (localizedString) {
      return localizedString;
    }
  } catch(e){}
  const locale = getState().localize.locale;
  console.warn(`localizedString for key ${key} not found in locale ${locale}`);
  return '';
}

export const localeConfig = (key) => (dispatch, getState) => {
  const value = key.split('.').reduce((a, b) => a[b], getState().localize.settings);
  if (!!value) {
    return value;
  }
  console.warn(`value for key ${key} not found in settings`);
  return null;
}
/*
export const changeLocale = (locale) => (dispatch, getState) => {
  return dispatch({
    type: 'SET_LOCALE',
    locale
  });
}
*/


// WEBPACK FOOTER //
// ./src/modules/localization/actions.js